/* ============================================================
   Bloop product gallery: working arrows, and images that are
   already there when you ask for them.

   THE ARROWS. On desktop with Dawn's thumbnail gallery layout the
   media list is not a scroller: Dawn shows the active image and sets
   the other media items to display: none, so scrollWidth equals
   clientWidth and Dawn's own slider handler has nothing to scroll.
   That is why the arrows appeared but did nothing. Rather than
   rebuild the gallery, they are pointed at the control Dawn does use
   here, the thumbnail buttons. Clicking a thumbnail is what calls
   setActiveMedia and keeps aria-current in step, so this inherits
   all of Dawn's behaviour including the screen reader announcements.

   WHY visibleThumbs FILTERS ON WIDTH. templates/product.json sets
   hide_variants, so on a product whose images are assigned to
   variants Dawn hides the thumbnails belonging to the colours you
   have not picked. They stay in the DOM at zero width. The first
   version of this script counted those too, so on a six image
   product showing four, the arrows ran past the last visible image
   into two dead clicks before wrapping. Measuring width is what
   separates "hidden because it belongs to another colour" from
   "hidden because it is not the active one", since on desktop every
   inactive media item is display: none either way.

   The list is rebuilt on every click rather than cached, so it
   follows the product's own image count and re-reads itself when the
   shopper switches colour and a different set of thumbnails appears.
   Nothing here is tied to a particular number of images.

   THE SPEED. Same root cause as the dead arrows: the inactive images
   are display: none AND loading="lazy", so the browser never fetched
   them and every arrow click started a cold request. Not a bandwidth
   problem, the files are 15 to 35KB; the request had simply not
   started. Preloading once the page is idle makes the switch instant
   and keeps the work off the critical path for first paint.

   The lightbox images are separate and much larger, so those are
   fetched only for the image being looked at, and only once the
   pointer is over the gallery, which is a fair predictor of a click.

   Loaded from sections/bloop-theme.liquid.
   ============================================================ */
(function () {
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };

  /* Only the thumbnails actually on screen for the current variant. */
  function visibleThumbs(gallery) {
    var all = Array.prototype.slice.call(
      gallery.querySelectorAll('.thumbnail-list__item')
    );
    var out = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].getBoundingClientRect().width > 0) {
        var button = all[i].querySelector('.thumbnail');
        if (button) out.push(button);
      }
    }
    return out;
  }

  function activeMediaId(gallery) {
    var item = gallery.querySelector('.product__media-item.is-active');
    return item ? item.getAttribute('data-media-id') : null;
  }

  function preloadGallery(gallery) {
    var imgs = gallery.querySelectorAll('.product__media-item img');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].getAttribute('loading') === 'lazy') {
        imgs[i].setAttribute('loading', 'eager');
      }
      /* display:none means the eager hint alone will not always kick
         off the fetch, so ask for the bytes directly. The browser
         serves the <img> from cache when it is finally shown. */
      var src = imgs[i].currentSrc || imgs[i].src;
      if (!imgs[i].complete && src) new Image().src = src;
    }
  }

  /* Only the one being looked at: these run to 2000px. */
  function preloadModal(mediaId) {
    if (!mediaId) return;
    var img = document.querySelector(
      '.product-media-modal__content [data-media-id="' + mediaId + '"]'
    );
    if (!img || img.complete) return;
    img.setAttribute('loading', 'eager');
    if (img.src) new Image().src = img.src;
  }

  function wire(gallery) {
    if (gallery.dataset.bloopArrows) return;
    gallery.dataset.bloopArrows = 'on';

    idle(function () { preloadGallery(gallery); });

    gallery.addEventListener('pointerenter', function () {
      preloadModal(activeMediaId(gallery));
    });

    var bar = gallery.querySelector('.slider-buttons');
    if (!bar) return;

    var buttons = Array.prototype.slice.call(bar.querySelectorAll('.slider-button'));
    if (!buttons.length) return;

    function enable() {
      for (var i = 0; i < buttons.length; i++) buttons[i].disabled = false;
    }

    /* Hide the arrows when the current variant leaves only one image
       to look at, and show them again when it does not. */
    function syncBar() {
      bar.style.display = visibleThumbs(gallery).length < 2 ? 'none' : '';
    }

    function step(direction) {
      var thumbs = visibleThumbs(gallery);
      if (thumbs.length < 2) return;

      var current = -1;
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('aria-current') === 'true') { current = i; break; }
      }
      if (current < 0) current = 0;

      thumbs[(current + direction + thumbs.length) % thumbs.length].click();

      /* Dawn re-runs its enable/disable pass on every slider update
         and concludes there is nothing to scroll, so undo that. */
      enable();
      setTimeout(function () {
        preloadModal(activeMediaId(gallery));
        syncBar();
      }, 50);
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        step(button.getAttribute('name') === 'previous' ? -1 : 1);
      }, true);
    });

    enable();
    syncBar();
    setTimeout(function () { enable(); syncBar(); }, 600);

    /* Picking a different colour swaps which thumbnails are on
       screen, so the arrows have to be re-evaluated. */
    gallery.addEventListener('click', function () { setTimeout(syncBar, 120); });
    document.addEventListener('change', function () { setTimeout(syncBar, 250); });
  }

  function scan(root) {
    var galleries = (root || document).querySelectorAll('media-gallery');
    for (var i = 0; i < galleries.length; i++) wire(galleries[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
